/**
 * `composites/landing` — presentational organisms for the VIP consultant-kit
 * landing page. Isolated layer: these import only from `react`,
 * `@pamperedchef/design-system`, `@/composites/landing/types` (value-object
 * types), and sibling `@/composites/landing/*` composites.
 */
export { Hero } from "./Hero";
export type { HeroProps } from "./Hero";

export { SectionHeading } from "./SectionHeading";
export type { SectionHeadingProps } from "./SectionHeading";

export { CheckList } from "./CheckList";
export type { CheckListProps } from "./CheckList";

export { Rating } from "./Rating";
export type { RatingProps } from "./Rating";

export { OfferCard } from "./OfferCard";
export type { OfferCardProps } from "./OfferCard";

export { Testimonial } from "./Testimonial";
export type { TestimonialProps } from "./Testimonial";

export { Steps } from "./Steps";
export type { StepsProps } from "./Steps";

export { VideoCallout } from "./VideoCallout";
export type { VideoCalloutProps } from "./VideoCallout";

export { ImageCollage } from "./ImageCollage";
export type { ImageCollageProps } from "./ImageCollage";

export { CalloutBanner } from "./CalloutBanner";
export type { CalloutBannerProps } from "./CalloutBanner";

export { ResponsiveImage } from "./ResponsiveImage";
export type { ResponsiveImageProps } from "./ResponsiveImage";

export { MinimalHeader } from "./MinimalHeader";
export type { MinimalHeaderProps } from "./MinimalHeader";

export { MinimalFooter } from "./MinimalFooter";
export type { MinimalFooterProps } from "./MinimalFooter";

export { GiftHero } from "./GiftHero";
export type { GiftHeroProps } from "./GiftHero";

export { FeatureCards } from "./FeatureCards";
export type {
	FeatureCardsProps,
	FeatureCardItem,
	FeatureCardTag,
	FeatureCardTagColor,
	FeatureCardCta
} from "./FeatureCards";

export { BrandValuesStrip } from "./BrandValuesStrip";
export type { BrandValuesStripProps, BrandValueItem } from "./BrandValuesStrip";
